// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1OBBN";
var _4 = "passengers-1Q36q";
var _5 = "item-3p1wD";
var _6 = "relink-2cNTG";
var _7 = "loading-10q8n";
var _8 = "accompanies-1jkdn";
var _9 = "accompanies__text-3PYXU";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "passengers", _5 as "item", _6 as "relink", _7 as "loading", _8 as "accompanies", _9 as "accompanies__text" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "passengers": _4, "item": _5, "relink": _6, "loading": _7, "accompanies": _8, "accompanies__text": _9 }
